import * as React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from 'helpers/theme';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    textTransform: 'uppercase',
    fontSize: theme.fontSizes.tiny,
    color: theme.colors.primaryWhite,
    fontWeight: 'bold'
  },
  detail: {
    color: theme.colors.primaryWhite,
    fontSize: theme.fontSizes.xSmall,
  }
}));

type Props = {
  className?: string;
  heading: string;
  detail: string;
};

function DetailField({ className, heading, detail }: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classNames(classes.root, className)}>
      <span className={classes.heading}>{`${heading}:`}</span>
      <p className={classes.detail}>{detail}</p>
    </div>
  );
}

export default DetailField;